import { render, staticRenderFns } from "./PhotoBooth.vue?vue&type=template&id=b377a140&scoped=true"
import script from "./PhotoBooth.vue?vue&type=script&lang=js"
export * from "./PhotoBooth.vue?vue&type=script&lang=js"
import style0 from "./PhotoBooth.vue?vue&type=style&index=0&id=b377a140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b377a140",
  null
  
)

export default component.exports